import { createAsyncThunk } from "@reduxjs/toolkit";
import { add_user_address } from "../../../../api/calls/user/add_user_address";
import { setMainModal } from "../../main";
import { addAddress } from "../address";
export const createAddressThunk = createAsyncThunk("address/create_address_thunk", async (data, { dispatch, getState }) => {
    const response = await add_user_address(data);
    if (response.success) {
        if (!!response.content) {
            dispatch(addAddress(response.content));
        }
    }
    else {
        dispatch(setMainModal({ title: "Something went wrong while adding your address!", messages: [response.message] }));
    }
    return response;
});
